import useSWRImmutable from 'swr/immutable';
import AccommodationService from '@/services/AccommodationService';

const useFacilities = () => useSWRImmutable(
    'accommodation-facilities',
    AccommodationService.getFacilities,
);

export default useFacilities;
